<template>
    <el-dialog :title="title+ ' 【'+user.realname+'】'" :visible="showflag" :width="width" @close="closeDialog">
        <div class="user-role-select-body">
            <el-checkbox-group v-model="checkedIds" :max="3">
                <el-checkbox v-for="role in roleList" :label="role.id" :key="role.id">{{role.rolename}}</el-checkbox>
            </el-checkbox-group>
        </div>
        
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getUserRoleData } from '@/api/user'
import { saveModel } from '@/api/common'

export default {
    name: 'userSetRole',
    mixins: [editutil],
    data() {
        return {
            model: {},
            user: {},
            roleList: [],
            checkedIds: [],
        }
    },
    methods: {
        loadData(){
            this.roleList = []
            this.checkedIds = []
            getUserRoleData(this.id).then(res=>{
                if(res.code == 1){
                    this.user = res.data.user
                    this.roleList = res.data.allRoles
                    this.checkedIds = res.data.checkedIds
                }
            })
        },
        //保存方法
        handleSubmit() {
            let config = {
                url:'/api/admin/user/saveRole',
                data: {
                    checkedIds: this.checkedIds,
                    userId: this.id
                }
            }
            saveModel(config).then(res=>{
                if(res.code===1){
                    this.$msgs("保存成功！");
                    this.closeDialog()
                }else{
                    this.$msg(res.msg)
                }
            }).catch();
        },
    }
}
</script>

<style>
.user-role-select-body{
    width:100%;
    height:500px;
    overflow-y:auto;
    overflow-x:hidden;
    margin-top: -30px;
    margin-left: 20px;
}
.user-role-select-body .el-checkbox-group{
    display: list-item;
    margin-top: 10px;
}
.user-role-select-body .el-checkbox-group .el-checkbox {
    width: 100%;
    margin-top: 10px;
}
</style>